export enum DeviationStatus {
  NEW_TRAIN = 'NEW_TRAIN',
  CONFLICT = 'CONFLICT',
  DEVIATION_HANDLED = 'DEVIATION_HANDLED'
}

export enum DriverRole {
  PLANNED = 'PLANNED',
  DEVIATING = 'DEVIATING'
}

export enum DriverSelectionType {
  NOT_EVALUATED = 'NOT_EVALUATED',
  SELECTED = 'SELECTED',
  NOT_SELECTED = 'NOT_SELECTED'
}
